import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

import { AuthService } from '@shared/auth';

/**
 * Returns the first routerLink in menu order, including nested `items`.
 */
function findFirstRouterLinkInMenu(items: MenuItem[]): string | null {
  for (const item of items) {
    if (item.disabled) {
      continue;
    }

    if (typeof item.routerLink === 'string' && item.routerLink.length > 0) {
      return item.routerLink;
    }

    const nested = findFirstRouterLinkInMenu(item.items ?? []);

    if (nested) {
      return nested;
    }
  }

  return null;
}

export const RedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const user = authService.user();

  let routerLink = '/login-unsuccessful';

  if (user.isInitialized && user.menuItems && user.menuItems.length > 0) {
    routerLink = findFirstRouterLinkInMenu(user.menuItems) ?? '/login-unsuccessful';
  }

  router.navigate([routerLink]);
  return true;
};
